import {
  computed,
  Injectable,
  resource,
  ResourceLoaderParams,
  ResourceRef,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ICustomTile } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { CustomTileGateway } from './custom-tile.gateway';

const EMPTY_TILE: ICustomTile = { isActive: false, texts: [] };

@Injectable({
  providedIn: 'root',
})
export class CustomTileStore {
  private readonly gateway: CustomTileGateway = new CustomTileGateway();
  private readonly tileId: WritableSignal<string> = signal('');
  readonly #customTileResource: ResourceRef<
    IApiResponse<ICustomTile> | undefined
  > = resource({
    params: this.tileId,
    loader: ({
      params,
    }: ResourceLoaderParams<string>): Promise<
      IApiResponse<ICustomTile> | undefined
    > => {
      return params
        ? firstValueFrom(this.gateway.get(params))
        : Promise.resolve(undefined);
    },
  });
  readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#customTileResource.isLoading()
  );
  readonly customTileResource: Signal<ICustomTile> = computed(
    (): ICustomTile => {
      return this.#customTileResource.hasValue()
        ? this.#customTileResource.value()?.data
          ? this.#customTileResource.value()!.data!
          : EMPTY_TILE
        : EMPTY_TILE;
    }
  );

  loadTile(tileId: string): void {
    this.tileId.set(tileId);
  }

  reload(): void {
    this.#customTileResource.reload();
  }

  save(query: ICustomTile): Promise<IApiResponse<ICustomTile>> {
    return firstValueFrom(this.gateway.save(query));
  }
}
